exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".chip__main{\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  background: #4860d9;\n  padding: 2px 13px;\n  border-radius: 6px;\n  max-width: 75%;\n  text-align: center;\n  color: white;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Chip/Chip.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Chip/Chip.css
// module chunks = 120